import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login'
import Home from './pages/Home';
import AOS from 'aos'
import 'aos/dist/aos.css'
import Signup from './pages/Signup';
import Userdashboard from './pages/Userdashboard'
import Userdashboardfundaccount from './components/userdashboardfundaccount/Userdashboardfundaccount'
import Userdashboardwithdraw from './components/userdashboardwithdraw/Userdashboardwithdraw';
import Userdashboardreferrals from './components/userdashboardreferrals/Userdashboardreferrals';
import Userdashboardplans from './components/userdashboardplans/Userdashboardplans';
import Userdashboardtransactions from './components/userdashboardtransactions/Userdashboardtransactions';
import Investments from './components/invesments/Investments';
import Profile from './components/profile/Profile'
import VerifyEmail from './pages/VerifyEmail';
import WithdrawalLogs from './components/WithdrawalLogs';
import Checkout from './components/Checkout';
import Admindashboard from './components/admindashboard/Admindashboard';
import Deposit from './components/deposit/Deposit';
import Aboutpage from './pages/Aboutpage';
import Faq from './pages/Faq';
import Terms from './pages/Terms';
import Risk from './pages/Risk';
import Reviews from './pages/Reviews';

import Policy from './pages/Policy';
import './App.css'

import Forex from './pages/forex/Forex';
import Indices from './pages/indices/Indices';
import Futures from './pages/futures/Futures';
import Stocks from './pages/stocks/Stocks';
import News from './pages/news/News';
import TechnicalAnalysisPage from './pages/technicalAnalysis/TechnicalAnalysisPage'
import Heatmaps from './pages/heatmaps/Heatmaps';
import Watchlist from './pages/watchlist/Watchlist';
import Team from './pages/team/Team'
import UserdashboardCopytrade from './components/userdashboardCopytrade/UserdashboardCopytrade';
import UserdashboardKyc from './components/userdashboardKyc/UserdashboardKyc';
import UserdashboardLiveTrading from './components/userdashboardLiveTrading/UserdashboardLiveTrading';
import UserdashboardRanking from './components/userdashboardRanking/UserdashboardRanking';
import UserdashboardTraders from './components/userdashboardTraders/UserdashboardTraders';
import Verify from './pages/verifyPage/Verify';
import PasswordReset from './components/passwordreset/PasswordReset';
import ForgotPassword from './components/forgotpassword/ForgotPassword';
import Bonds from './pages/bonds/Bonds';
import Options from './pages/options/Options';
import Commodities from './pages/commodities/Commodities';
import OtpVerification from './pages/OtpVerification';

function App() {
  useEffect(() => {
    AOS.init({
      offset: 60,
      duration: 500,
      easing: 'ease-in-sine',
      delay: 100,
    })
    AOS.refresh()
    // duration=1200;
  }, [])


  const route = 'https://server-livesynch.onrender.com' 
  // const route = 'http://localhost:5000'

  return (
    <>
      <AnimatePresence >
        <Router>
          <motion.div className="App"
            key={Routes.Route}
            initial="initialState"
            animate="animateState"
            exit="exitState"
            transition={{ duration: 0.2 }}
            variants={{
              initialState: {
                clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
              },
              animateState: {
                clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
              },
              exitState: {
                clipPath: "polygon(50% 0, 50% 0, 50% 100%, 50% 100%)",
              }
            }}
          >
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/login' element={<Login route={route} />} />
              <Route path='/signup' element={<Signup route={route} />} />
              <Route path='/dashboard' element={<Userdashboard route={route} />} />
              <Route path='/fundwallet' element={<Userdashboardfundaccount route={route} />} />
              <Route path='/referrals' element={<Userdashboardreferrals route={route} />} />
              <Route path='/withdraw' element={<Userdashboardwithdraw route={route} />} />
              <Route path='/plans' element={<Userdashboardplans route={route} />} />
              <Route path='/transactions' element={<Userdashboardtransactions route={route} />} />
              <Route path='/investments' element={<Investments route={route} />} />
              <Route path='/settings' element={<Profile route={route} />} />
              <Route path='/user/:id' element={<VerifyEmail route={route} />} />
              <Route path='/withdrawlogs' element={<WithdrawalLogs route={route} />} />
              <Route path='/checkout' element={<Checkout route={route} />} />
              <Route path='/admin' element={<Admindashboard route={route} />}>
              </Route>
              <Route path='/deposit' element={<Deposit route={route} />} />
              <Route path='/about' element={<Aboutpage />} />
              <Route path='/faq' element={<Faq />} />
              <Route path='/privacy' element={<Policy />} />
              <Route path='/terms' element={<Terms />} />
              <Route path='/risk' element={<Risk />} />
              <Route path='/reviews' element={<Reviews />} />
              <Route path='/forex' element={<Forex />} />
              <Route path='/futures' element={<Futures />} />
              <Route path='/indices' element={<Indices />} />
              <Route path='/stocks' element={<Stocks />} />
              <Route path='/news' element={<News />} />
              <Route path='/technical-analysis' element={<TechnicalAnalysisPage />} />
              <Route path='/heatmaps' element={<Heatmaps />} />
              <Route path='/watchlists' element={<Watchlist />} />
              <Route path='/team' element={<Team />} />
              <Route path='/usercopytrade' element={<UserdashboardCopytrade route={route} />} />
              <Route path='/traders' element={<UserdashboardTraders route={route} />} />
              <Route path='/live-trading' element={<UserdashboardLiveTrading route={route} />} />
              <Route path='/ranking' element={<UserdashboardRanking route={route} />} />
              <Route path='/kyc' element={<UserdashboardKyc route={route} />} />
              <Route path='/verify' element={<Verify />} />
              <Route path=':id/verify/:token' element={<VerifyEmail route={route} />} />
              <Route path='/passwordreset' element={<ForgotPassword route={route} />} />
              <Route path='/resetpassword/:token' element={<PasswordReset route={route} />} />
              <Route path='/bonds' element={<Bonds />} />
              <Route path='/options' element={<Options />} />
              <Route path='/commodities' element={<Commodities />} />
              <Route path='/verify-otp' element={<OtpVerification route={route} />} />
            </Routes>
          </motion.div>
        </Router>
      </AnimatePresence>
    </>
  );
}

export default App
